import React, { useState, useEffect, Fragment } from "react";
import SessionType from "./SessionType";
import DoYouWish from "./DoYouWish";
import Feedbacks from "../Create/FeedbacksPanel";
import PersonalData from "./PersonalData";
import Interludes from "../Create/InterludesPanel";
import Conclusions from "../Create/ConclusionPanel";
import ChainedSession from "../Create/ChainedSessionPanel";
import FadeIn from "react-fade-in";
import { Card, H3 } from "@blueprintjs/core";

const AdditionalInfos = ({
  protocol,
  feedbacks,
  handleChangeFeedbacks,
  handleChangeInput,
  interludes,
  sessionId,
  handleChangeInterludes,
  deleteAllInterludes,
  deleteAllConclusions,
  deleteChainedSession,
  handleChangeChainedSession,
  conclusions,
  chainedSession,
  handleChangeConclusion,
  addPersonalQuestion,
  handleRemovePersonalQuestion,
  personalQuestions,
  emptyPersonalQuestions,
  emptyFeedbacks,
  type,
  editMode,
  hasBeenPlayed,
}) => {
  const [step, setStep] = useState(0);
  const [addFeedbacks, setAddFeedbacks] = useState(false);
  const [addPerso, setAddPerso] = useState(false);
  const [choseType, setChoseType] = useState(false);
  const [addInterludes, setAddInterludes] = useState("");
  const [addConclusion, setAddConclusion] = useState(false);
  const [addChainedSession, setAddChainedSession] = useState(false);
  const handleChainedSessionAnswer = (answer) => {
    setAddChainedSession(answer);
    if (answer === false) {
      deleteChainedSession();
    }
  };

  let goNextStep = (x) => {
    if (x > step) {
      setStep(x);
    }
  };

  useEffect(() => {
    if (feedbacks && feedbacks.length) {
      setAddFeedbacks(true);
    }
    if (type && type !== "") {
      setChoseType(true);
    }
    if (personalQuestions && personalQuestions.length) {
      setAddPerso(true);
    }
    if (interludes && interludes.length) {
      setAddInterludes(true);
    }
    if (conclusions && conclusions.length) {
      setAddConclusion(true);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      {/* FEEDBACK */}
      <H3 className="text-center margin-bottom-medium margin-top-medium">
        Add Feedback Questions?
      </H3>
      <FadeIn>
        <Card>
          <DoYouWish
            handleAnswer={setAddFeedbacks}
            goNextStep={goNextStep}
            nextStep={1}
            alreadyFilled={addFeedbacks}
            emptyData={emptyFeedbacks}
            editMode={editMode}
          />
          {addFeedbacks && (
            <FadeIn>
              <Feedbacks
                feedbacks={feedbacks}
                onChangeFeedbacks={handleChangeFeedbacks}
                hasBeenPlayed={hasBeenPlayed}
              />
            </FadeIn>
          )}
        </Card>
      </FadeIn>

      {/* PERSONAL DATA */}
      {step >= 1 &&
        ((addFeedbacks && feedbacks.length > 0) ||
          !addFeedbacks ||
          step > 1) && (
          <FadeIn>
            <H3 className="text-center margin-bottom-medium margin-top-medium">
              Ask personal information of the participant?
            </H3>
            <Card>
              <DoYouWish
                handleAnswer={setAddPerso}
                goNextStep={goNextStep}
                nextStep={protocol === "MC" || protocol === "CM" ? 3 : 2}
                emptyData={emptyPersonalQuestions}
                alreadyFilled={addPerso}
                editMode={editMode}
              />
              {addPerso && (
                <FadeIn>
                  <PersonalData
                    addPersonalQuestion={addPersonalQuestion}
                    personalQuestions={personalQuestions}
                    hasBeenPlayed={hasBeenPlayed}
                    handleRemovePersonalQuestion={handleRemovePersonalQuestion}
                  />
                </FadeIn>
              )}
            </Card>
          </FadeIn>
        )}

      {!(protocol === "MC" || protocol === "CM") && (
        <>
          {(choseType ||
            (step >= 2 &&
              ((addPerso &&
                personalQuestions &&
                personalQuestions.length > 0) ||
                !addPerso ||
                step > 2))) && (
            <Fragment>
              <H3 className="text-center margin-bottom-medium margin-top-medium">
                Chose Your Session Type*
              </H3>
              <FadeIn>
                <SessionType
                  onInputChange={handleChangeInput}
                  goNextStep={goNextStep}
                  nextStep={3}
                  type={type}
                />
              </FadeIn>
            </Fragment>
          )}
        </>
      )}
      {/* SESSION TYPE  */}

      {/* INTRODUCTION  */}
      {step >= 3 && (
        <Fragment>
          <H3 className="text-center margin-bottom-medium margin-top-medium">
            Add Introduction (images or videos) ?
          </H3>
          <FadeIn>
            <Card>
              <DoYouWish
                handleAnswer={setAddInterludes}
                goNextStep={goNextStep}
                nextStep={4}
                alreadyFilled={addInterludes}
                emptyData={deleteAllInterludes}
                editMode={editMode}
              />
              {addInterludes && (
                <FadeIn>
                  <Interludes
                    sessionId={sessionId}
                    interludes={interludes}
                    onChangeInterludes={handleChangeInterludes}
                  />
                </FadeIn>
              )}
            </Card>
          </FadeIn>
        </Fragment>
      )}

      {/* CONCLUSION  */}
      {(step === 5 ||
        (step >= 4 &&
          (addInterludes === false ||
            (addInterludes === true && interludes.length > 0)))) && (
        <Fragment>
          <H3 className="text-center margin-bottom-medium margin-top-medium">
            Add Conclusion (images or videos) ?
          </H3>
          <FadeIn>
            <Card>
              <DoYouWish
                question="Add Conclusions?"
                handleAnswer={setAddConclusion}
                goNextStep={goNextStep}
                nextStep={5}
                alreadyFilled={addConclusion}
                emptyData={deleteAllConclusions}
                editMode={editMode}
              />
              {addConclusion && (
                <FadeIn>
                  <Conclusions
                    sessionId={sessionId}
                    conclusions={conclusions}
                    onChangeConclusion={handleChangeConclusion}
                  />
                </FadeIn>
              )}
            </Card>
          </FadeIn>
        </Fragment>
      )}
      {/* LINK TO NEXT SESSION  */}

      {type === "AUTONOMOUS" &&
        step >= 5 &&
        (addConclusion === false ||
          (addConclusion === true && conclusions.length > 0)) && (
          <Fragment>
            <H3 className="text-center margin-bottom-medium margin-top-medium">
              Add Link to Another Session?
            </H3>
            <FadeIn>
              <Card>
                <DoYouWish
                  question="Add a link to next session?"
                  handleAnswer={handleChainedSessionAnswer}
                  goNextStep={goNextStep}
                  nextStep={6}
                  alreadyFilled={!!chainedSession}
                  editMode={editMode}
                />
                {addChainedSession && (
                  <FadeIn>
                    <ChainedSession
                      sessionId={sessionId}
                      chainedSession={chainedSession}
                      onChangeChainedSession={handleChangeChainedSession}
                    />
                  </FadeIn>
                )}
              </Card>
            </FadeIn>
          </Fragment>
        )}
    </Fragment>
  );
};

export default AdditionalInfos;
